export const compactHash = (obj: {
  [s: string]: unknown;
}): { [s: string]: unknown } => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
};
